(ns common.schema.entities.workspace.kyc.questions.smo
  (:require
   [common.country :as country]
   [common.schema.entities.workspace.kyc.kyc-options :as kyc-options]))

(def management-position-options
  [{:key :management-position/ceo
    :translations {:en "Chief Executive Officer (CEO)"
                   :fi "Toimitusjohtaja"}}
   {:key :management-position/cfo
    :translations {:en "Chief Financial Officer (CFO)"
                   :fi "Talousjohtaja"}}
   {:key :management-position/coo
    :translations {:en "Chief Operating Officer (COO)"
                   :fi "Operatiivinen johtaja"}}
   {:key :management-position/managing-director
    :translations {:en "Managing Director"
                   :fi "Johtava johtaja"}}
   {:key :management-position/deputy-director
    :translations {:en "Deputy Director"
                   :fi "Apulaisjohtaja"}}
   {:key :management-position/senior-manager
    :translations {:en "Senior Manager"
                   :fi "Ylempi johtaja"}}
   {:key :management-position/head-of-department
    :translations {:en "Head of Department"
                   :fi "Osastonjohtaja"}}
   {:key :management-position/other
    :translations {:en "Other, specify"
                   :fi "Muu, tarkenna"}}])

(def all-questions
  {:kyc-smo/first-name
   {:data/type        :data.type/text-simple
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "First name"
                       :fi "Etunimi"}}

   :kyc-smo/last-name
   {:data/type        :data.type/text-simple
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Last name"
                       :fi "Sukunimi"}}

   :kyc-smo/dob
   {:data/type        :data.type/date
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Date of birth"
                       :fi "Syntymäaika"}}

   :kyc-smo/pob
   {:data/type        :data.type/text-simple
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Place of birth"
                       :fi "Syntymäpaikka"}}

   :kyc-smo/cob
   {:data/type        :data.type/text-simple
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Country of birth"
                       :fi "Syntymämaa"}}

   :kyc-smo/nationality
   {:data/type        :data.type/keyword
    :options          country/options
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Nationality"
                       :fi "Kansalaisuus"}}

   :kyc-smo/country
   {:data/type        :data.type/keyword
    :options          country/options
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Country of residence"
                       :fi "Asuinmaa"}}

   :kyc-smo/management-position
   {:data/type        :data.type/keyword
    :options          management-position-options
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Management position"
                       :fi "Johtotehtävä"}}

   :kyc-smo/management-position-other
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers]
                         (= :management-position/other (:kyc-smo/management-position answers)))
    :mandatory-field?  (fn [answers kyc-process]
                         (and (= :management-position/other (:kyc-smo/management-position answers))
                              (not= (:kyc-process/status kyc-process)
                                    :kyc-process.status/draft)))
    :translations      {:en "Please specify management position"}}

   ;; Tax residency section (similar to UBO)
   :kyc-smo/tax-countries
   {:data/type        :data.type/text-edn
    :edn-data/type    :edn-data.type/tax-recidencies
    :options          country/options
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Countries of tax residence"
                       :fi "Verotusmaat"}}

   :kyc-smo/usa-tax-residence
   {:data/type        :data.type/keyword
    :options          kyc-options/yes-no-options
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "USA citizenship and tax residency"
                       :fi "Yhdysvaltain kansalaisuus ja verovelvollisuus"}}

   :kyc-smo/non-usa-confirmation
   {:data/type         :data.type/confirm
    :conditional-field (fn [answers]
                         (= :no (:kyc-smo/usa-tax-residence answers)))
    :mandatory-field?  (fn [_answers kyc-process]
                         (not= (:kyc-process/status kyc-process)
                               :kyc-process.status/draft))
    :translations      {:en
                        (str
                         "I hereby confirm that this person is not a citizen of the United States "
                         "of America or tax resident in the USA.")
                        :fi
                        (str "Vahvistan, että tämä henkilö ei ole Yhdysvaltain kansalainen tai "
                             "verovelvollinen Yhdysvalloissa.")}}

   :kyc-smo/usa-confirmation
   {:data/type         :data.type/confirm
    :conditional-field (fn [answers]
                         (= :yes (:kyc-smo/usa-tax-residence answers)))
    :mandatory-field?  (fn [_answers kyc-process]
                         (not= (:kyc-process/status kyc-process)
                               :kyc-process.status/draft))
    :translations      {:en
                        (str "I hereby confirm that this person is a citizen of the United States "
                             "of America and/or tax resident in the USA, and that he/she has reported "
                             "this tax residency and his/her Tax Identification Number (TIN) above.")
                        :fi
                        (str "Vahvistan, että tämä henkilö on Yhdysvaltain kansalainen ja/tai "
                             "verovelvollinen Yhdysvalloissa, ja että hän on ilmoittanut "
                             "verovelvollisuutensa sekä veronumeronsa tällä lomakkeella")}}

   ;; PEP section (similar to UBO)
   :kyc-smo/pep
   {:data/type        :data.type/keyword
    :options          [{:key :yes
                        :translations {:en "Yes"
                                       :fi "Kyllä"}}
                       {:key :no
                        :translations {:en "No"
                                       :fi "Ei"}}]
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :translations     {:en "Is the person politically exposed?"
                       :fi "Onko henkilö poliittisesti vaikutusvaltainen?"}}

   :kyc-smo.pep/country
   {:data/type         :data.type/keyword
    :options           country/options
    :conditional-field (fn [answers]
                         (= :yes (:kyc-smo/pep answers)))
    :mandatory-field?  (fn [answers kyc-process]
                         (and (= :yes (:kyc-smo/pep answers))
                              (not= (:kyc-process/status kyc-process)
                                    :kyc-process.status/draft)))
    :translations      {:en "In which country does this person hold or has held a prominent public function?"
                        :fi "Missä valtiossa henkilö hoitaa tai on hoitanut merkittävää julkista virkaa?"}}

   :kyc-smo.pep/political-function
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers]
                         (= :yes (:kyc-smo/pep answers)))
    :mandatory-field?  (fn [answers kyc-process]
                         (and (= :yes (:kyc-smo/pep answers))
                              (not= (:kyc-process/status kyc-process)
                                    :kyc-process.status/draft)))
    :translations      {:en "Specify the political function"
                        :fi "Tarkenna poliittinen tehtävä"}}

   :kyc-smo.pep/relationship-to-smo
   {:data/type         :data.type/keyword
    :options           [{:key :person-himself
                         :translations {:en "The person himself/herself"
                                        :fi "Henkilö itse"}}
                        {:key :family-member
                         :translations {:en "Family member of a PEP"
                                        :fi "PEP-henkilön perheenjäsen"}}
                        {:key :other
                         :translations {:en "Other close associate"
                                        :fi "Muu läheinen yhteistyökumppani"}}]
    :conditional-field (fn [answers]
                         (= :yes (:kyc-smo/pep answers)))
    :mandatory-field?  (fn [answers kyc-process]
                         (and (= :yes (:kyc-smo/pep answers))
                              (not= (:kyc-process/status kyc-process)
                                    :kyc-process.status/draft)))
    :translations      {:en "Relationship to SMO"
                        :fi "Suhde SMO:hon"}}

   :kyc-smo.pep/name
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers]
                         (and (= :yes (:kyc-smo/pep answers))
                              (some #{(:kyc-smo.pep/relationship-to-smo answers)}
                                    [:family-member :other])))
    :mandatory-field?  (fn [answers kyc-process]
                         (and (= :yes (:kyc-smo/pep answers))
                              (some #{(:kyc-smo.pep/relationship-to-smo answers)}
                                    [:family-member :other])
                              (not= (:kyc-process/status kyc-process)
                                    :kyc-process.status/draft)))
    :translations      {:en "Name of the politically exposed person"
                        :fi "Poliittisesti vaikutusvaltaisen henkilön nimi"}}})
